import React from "react"
import Item from "./Item"
import { getCssSizeValue, getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import Marquee from "react-fast-marquee"
import { useIsMobile } from "@/hooks/useDevice"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const CarouselItem = styled(Item)`
	height: auto;
	width: ${getCssSizeValue(293, BREAKPOINTS.MOBILE)};
	margin: 0 ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		width: ${getCssSizeValue(427, BREAKPOINTS.TABLET)};
		margin: 0 calc(var(--grid-gap) / 2);
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		width: ${getCssSizeValue(427)};
	}
`

export default function CarouselVariant({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const partners = data?.partners || []
	const isMobile = useIsMobile()
	const speed = isMobile ? 75 : 150

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription || null} />
			<Marquee speed={speed} className={`carousel-variant`}>
				{partners.map((partner, index) => (
					<CarouselItem key={getMapKey(partner, index)} data={partner} />
				))}
				{partners.length < 5 &&
					partners.map((partner, index) => <CarouselItem key={`duplicate-${getMapKey(partner, index)}`} data={partner} />)}
			</Marquee>
		</section>
	)
}
